const navBar = document.querySelector('nav.navbar')
const ctaBox = document.querySelector('.cta-box')
const style = getComputedStyle(document.body)

let stickySideInfo = null
if (document.querySelector('.sticky-side-info'))
  stickySideInfo = document.querySelector('.sticky-side-info')
let clickDetected = false

let lastScrollTop = 0
const footer = document.querySelector('footer')
const footerPosition = footer.offsetTop
const windowHeight = window.innerHeight

if (stickySideInfo) {
  if (!navBar.classList.contains('nav-float-hide')) {
    stickySideInfo.classList.remove('sticky-top-0')
    stickySideInfo.classList.add('sticky-top-nav-show')
  }
}

window.addEventListener('scroll', function () {
  let currentScroll = window.scrollY
  const isFooterVisible = currentScroll >= footerPosition - windowHeight

  if (currentScroll > 300) {
    if (!ctaBox.classList.contains('cta-box-float'))
      ctaBox.classList.add('cta-box-float')
  } else {
    ctaBox.classList.remove('cta-box-float')
  }

  if (currentScroll > parseFloat(style.getPropertyValue('--header-height'))) {
    
    if (currentScroll > lastScrollTop) {
      navBar.classList.remove('nav-float-hide')
      navBar.classList.add('nav-float-show', 'nav-float')
      if (stickySideInfo) {
        stickySideInfo.classList.remove('sticky-top-nav-show')
        stickySideInfo.classList.add('sticky-top-0')
      }

      document
        .querySelectorAll('.menu-item-has-children')
        .forEach((element) => {
          element.classList.remove('open')
        })
    } else if (currentScroll < lastScrollTop) {
      // navBar.classList.remove('nav-float-hide')
      // navBar.classList.add('nav-float-show', 'nav-float')
      if (stickySideInfo) {
        stickySideInfo.classList.remove('sticky-top-0')
        stickySideInfo.classList.add('sticky-top-nav-show')
      }
    }
  } else {
    navBar.classList.remove('nav-float-show', 'nav-float')
    navBar.classList.add('nav-float-hide')
  }

  // Update last scroll position
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
})
